import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'secondary';
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold rounded-full transition-all duration-200 shadow-sm hover:shadow-md';
  const variants = {
    primary: 'bg-brand-orange text-white hover:bg-orange-500 px-8 py-4 text-lg md:text-xl',
    secondary: 'bg-brand-blue text-white hover:bg-blue-500 px-6 py-3 text-base md:text-lg'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${className}`} {...props} data-id="element-141">
      {children}
    </motion.button>;
}